import { render, staticRenderFns } from "./OikAutocomplete.vue?vue&type=template&id=6b3e8969&scoped=true&"
import script from "./OikAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./OikAutocomplete.vue?vue&type=script&lang=ts&"
import style0 from "./OikAutocomplete.vue?vue&type=style&index=0&id=6b3e8969&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e8969",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
